import LogoBde from "../../assets/img/logo-bde.png";

const navbarText = {
  title: "BDE",
  logo: LogoBde,
  links: {
    accueil: "Accueil",
    clubsAssos: "Clubs et Associations",
    infos: "Informations Pratiques",
    nePasOublier: "Ne pas oublier",
    vivreAStrasbourg: "Vivre à Strasbourg",
    vivreATps: "Vivre à TPS",
    partenaires: "Partenaires",
    campagnes: "Campagnes",
  },
};

export default navbarText;
